import { ChatIcon } from 'components/common/Icons';

import { Box, Button, Flex, Typography } from '@project44/manifest-ds';
import { useTranslation } from '@project44/translations-utils';

import { IChatBanner, ILaunchBanner } from './ChatBanner.types';

function LaunchBanner({ handleLaunch }: ILaunchBanner) {
  const { t } = useTranslation();

  return (
    <>
      <Flex align="start" gap="medium">
        <ChatIcon />
        <Flex orientation="vertical">
          <Typography variant="bodyBold">{t('core.chat.letsChat')}</Typography>
          <Typography>{t('core.chat.filterFaster')}</Typography>
        </Flex>
      </Flex>
      <Button size="small" onPress={handleLaunch} data-testid="launch-button">
        {t('core.chat.launch')}
      </Button>
    </>
  );
}

function ActiveBanner() {
  const { t } = useTranslation();

  return (
    <Flex align="start" gap="medium" data-testid="active-banner">
      <ChatIcon />
      <Typography variant="bodyBold">{t('core.chat.powered')}</Typography>
    </Flex>
  );
}

function ChatBanner({ isActive, handleLaunch }: IChatBanner) {
  return (
    <Box
      css={{ padding: '$small $medium 0 $medium' }}
      data-testid="chat-banner"
    >
      <Flex
        align="center"
        justify="between"
        css={{
          backgroundColor: '$palette-purple-50',
          padding: '$medium',
          borderRadius: '4px',
        }}
      >
        {isActive ? (
          <ActiveBanner />
        ) : (
          <LaunchBanner handleLaunch={handleLaunch} />
        )}
      </Flex>
    </Box>
  );
}

export default ChatBanner;
